import styled from 'styled-components';

export const Btn = styled.button`
  width: ${p => (p.buttonWidth ? `${p.buttonWidth}px` : '100%')};
  background: linear-gradient(110.35deg, #53b2fe 13.53%, #065af3 118.83%);
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  outline: 0;
  border: 0;
  cursor: pointer;
  font-family: 'Lato';
  font-size: 16px;
  font-weight: 900;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  padding: 16px 0;
  ${p =>
    p.isDisabled &&
    `
        background: #DADADA;
        pointer-events: none;
        box-shadow: none;
    `}
`;

export const BtnLoader = styled.button`
  width: ${p => (p.buttonWidth ? `${p.buttonWidth}px` : '100%')};
  background: linear-gradient(110.35deg, #53b2fe 13.53%, #065af3 118.83%);
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  outline: 0;
  border: 0;
  cursor: pointer;
  font-family: 'Lato';
  font-size: 16px;
  font-weight: 900;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  ${p =>
    p.isDisabled &&
    `
        background: #DADADA;
        pointer-events: none;
        box-shadow: none;
    `}
`;
